import {
  createStackNavigator,
  StackScreenProps,
} from '@react-navigation/stack';
import React from 'react';

// import { SubscriptionPlanDetail } from '@components/Profile/SubscriptionPlanDetail.web';
import { TeamDetailPage as SubscriptionPlanDetail } from '@components/Profile/TeamDetailPage/index.web';
import { Product, Team, User } from '@graphql/generated';
import { AddTeamMembersModalStack } from '@navigation/addMembers/add-team-members-modal-stack';
import { MyAccount } from '@screens/Profile/MyAccount.web';
import { MyProfile } from '@screens/Profile/MyProfile.web';

export type ProfileStackParamsList = {
  tabs: undefined;
  'my-profile-mobile': undefined;
  subscriptionPlanDetail: {
    teamUUId: Team['uuid'];
    openAfterCreate?: boolean;
  };
  'subscription-created': { teamUUId: Team['uuid']; productId: Product['id'] };
  'subscription-edit': { teamUUId: Team['uuid']; productId: Product['id'] };
  'subscription-plans': undefined;
  'add-team-members': {
    teamUUId: Team['uuid'];
    initialUsers: User[];
  };
};

export type ProfileStackScreenProps<T extends keyof ProfileStackParamsList> =
  StackScreenProps<ProfileStackParamsList, T>;

const Stack = createStackNavigator<ProfileStackParamsList>();

const ProfileStack: React.FC = () => {
  return (
    <Stack.Navigator>
      <Stack.Screen
        name='tabs'
        component={MyAccount}
        options={{
          headerShown: false,
        }}
      />
      <Stack.Screen
        name='my-profile-mobile'
        component={MyProfile}
        options={{
          headerShown: false,
        }}
      />
      <Stack.Screen
        name='subscriptionPlanDetail'
        component={SubscriptionPlanDetail}
        options={{
          headerShown: false,
        }}
      />
      <Stack.Screen
        name='subscription-created'
        component={MyAccount}
        options={{
          headerShown: false,
        }}
      />
      <Stack.Screen
        name='subscription-edit'
        component={MyAccount}
        options={{
          headerShown: false,
        }}
      />
      <Stack.Screen
        name='subscription-plans'
        component={MyAccount}
        options={{
          headerShown: false,
        }}
      />
      <Stack.Screen
        name='add-team-members'
        component={AddTeamMembersModalStack}
        options={{ headerShown: false, presentation: 'transparentModal' }}
      />
    </Stack.Navigator>
  );
};

export default ProfileStack;
